<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-base px-6 py-12">
    <a href="/" class="flex items-center gap-2.5 mb-8">
      <img src="@/assets/logo-2.png" alt="Akademi Siber" class="h-10" />
      <span class="text-lg font-extrabold text-white">Akademi<span class="text-brand">Siber</span></span>
    </a>

    <div class="card w-full max-w-md p-8">
      <h1 class="text-2xl font-extrabold text-white mb-1">Resend Confirmation</h1>
      <p class="text-ink-muted text-sm mb-6">Enter your email to receive a new confirmation email.</p>

      <form @submit.prevent="resetPassword" class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-ink-muted mb-1.5" for="email">Email</label>
          <input v-model="email" class="input" id="email" placeholder="you@example.com" type="email" />
        </div>
        <button class="btn-primary w-full justify-center py-3" :disabled="isLoading || !email" type="submit">
          {{ isLoading ? "Sending..." : "Send Email Confirmation" }}
        </button>
      </form>

      <p v-if="message" :class="['text-center text-sm mt-4', isError ? 'text-brand' : 'text-success']">
        {{ message }}
      </p>

      <p class="text-center text-sm text-ink-muted mt-6">
        Already confirmed your email?
        <a class="font-semibold text-brand hover:text-brand-light" href="/login">Sign In</a>
      </p>
    </div>

    <p class="text-ink-faint text-xs mt-8">© 2025 SiberLab ID</p>
  </div>
</template>

<script>
import toastr from "toastr"; // Importing Toastr
import "toastr/build/toastr.min.css"; // Importing Toastr CSS
import apiClient from "@/axiosConfig"; // Importing Axios configuration

toastr.options = {
  positionClass: "toast-bottom-right",
  closeButton: true,
  progressBar: true,
  timeOut: 5000,
};

export default {
  name: "ResendConfirmation",
  data() {
    return {
      email: "",
      isLoading: false,
      message: "",
      isError: false,
    };
  },
  methods: {
    async resetPassword() {
      this.isLoading = true;
      this.message = "";
      this.isError = false;

      try {
        // Make POST request to resend email confirmation
        await apiClient.post("/auth/resend-confirmation", { email: this.email });

        // Show success message
        this.message = "Confirmation email resent successfully!";
        toastr.success(this.message, "Success");

        // Clear email field
        this.email = "";
      } catch (error) {
        // Handle errors based on response code
        if (error.response?.status === 404) {
          this.message = "An error occurred. Please try again.";
        } else {
          this.message = error.response?.data?.message || "An error occurred. Please try again.";
        }
        this.isError = true;
        toastr.error(this.message, "Error");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
